module.exports = __webpack_public_path__ + "images/icono-6-go-stop.jpg";